export const callStatisticsMock = [
  {
    traceId: '5b582c1e-d1eb-475e-92f0-ee213a15adf0@sns.mobile',
    createdAt: 1537199910623,
    lastModifiedTime: '2018-09-17T15:57:49.438Z',
    objectId: '5b9fcf2672798d7e7f07bce7',
    sip_proxy: {
      sipProxyReceivedSipMessage: {
        sipCodes: {
          eventDateTime: '2018-09-17T15:57:49.438Z',
          value: [
            '180',
            '180',
            '180',
            '180',
          ],
        },
        INVITE: {
          eventDateTime: '2018-09-17T15:57:45.889Z',
          value: 1,
        },
        ACK: {
          eventDateTime: '2018-09-17T15:58:16.141Z',
          value: 1,
        },
        CANCEL: {
          eventDateTime: '2018-09-17T15:58:16.104Z',
          value: 1,
        },
      },
    },
    updatedAt: 1537199911440,
    event_manager: {
      evMgrPstnMUCGivenTNs: {
        pstncall: {
          eventDateTime: '2018-09-17T15:57:45.906Z',
          value: 1,
        },
      },
    },
    fromTN: '+18453252530',
    toTN: '+17027493344',
    callDateTime: '2018-09-17T15:57:45.889Z',
  },
  {
    traceId: 'e4aa7322-5888-4f45-88df-3d60a0e3cda8@sns.mobile',
    createdAt: 1537199910640,
    lastModifiedTime: '2018-09-17T15:57:42.293Z',
    objectId: '5b9fcf2672798d7e7f07bce8',
    sip_proxy: {
      sipProxyReceivedSipMessage: {
        sipCodes: {
          eventDateTime: '2018-09-17T15:57:42.973Z',
          value: [
            '180',
            '180',
            '180',
            '180',
          ],
        },
        ACK: {
          eventDateTime: '2018-09-17T15:58:10.281Z',
          value: 1,
        },
        CANCEL: {
          eventDateTime: '2018-09-17T15:58:10.240Z',
          value: 1,
        },
        INVITE: {
          eventDateTime: '2018-09-17T15:57:42.273Z',
          value: 1,
        },
      },
    },
    updatedAt: 1537199911225,
    notification_manager: {
      ntMgrApnNotifyUsingTLS: {
        eventDateTime: '2018-09-17T15:57:43.061Z',
        value: 1,
      },
    },
    callDateTime: '2018-09-17T15:57:42.273Z',
    event_manager: {
      evMgrPstnMUCGivenTNs: {
        pstncall: {
          eventDateTime: '2018-09-17T15:57:42.293Z',
          value: 1,
        },
      },
    },
    fromTN: '+14057991569',
    toTN: '+14057997251',
  },
  {
    traceId: '4fdccaae-987f-4da8-988a-a05b44dc2cbe@sns.mobile',
    createdAt: 1537199910662,
    lastModifiedTime: '2018-09-17T15:57:42.359Z',
    objectId: '5b9fcf2672798d7e7f07bce9',
    sip_proxy: {
      sipProxyReceivedSipMessage: {
        sipCodes: {
          eventDateTime: '2018-09-17T15:57:42.565Z',
          value: [
            '180',
            '180',
            '180',
            '180',
          ],
        },
        ACK: {
          eventDateTime: '2018-09-17T15:58:10.864Z',
          value: 1,
        },
        CANCEL: {
          eventDateTime: '2018-09-17T15:58:10.817Z',
          value: 1,
        },
        INVITE: {
          eventDateTime: '2018-09-17T15:57:42.359Z',
          value: 1,
        },
      },
    },
    updatedAt: 1537199911194,
    notification_manager: {
      ntMgrApnNotifyUsingTLS: {
        eventDateTime: '2018-09-17T15:57:43.012Z',
        value: 1,
      },
    },
    event_manager: {
      evMgrPstnMUCGivenTNs: {
        pstncall: {
          eventDateTime: '2018-09-17T15:57:42.381Z',
          value: 1,
        },
      },
    },
    fromTN: '+14057993783',
    toTN: '+14057997251',
    callDateTime: '2018-09-17T15:57:42.359Z',
  },
];

export default {
  callStatisticsMock,
};
